import styled, {css} from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"

import mainTheme from "@irati/ui/src/global/theme"
import {FlexRow as FlexRowBase} from "../../../shared"

export const IconsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;
  gap: ${mainTheme.spacing.half};
`

export const FlexRow = styled(FlexRowBase)`
  align-items: start;
  ${({isPrivate}) => isPrivate && "padding-top: 12px;"}
  ${minWidthMedia.tablet`
    ${({isPrivate}) => isPrivate && "padding-top: 0px;"}
  `}
`

export const BodyContainer = styled.div`
  margin-left: ${padding.tiny};
  ${minWidthMedia.tablet`
    margin-left: ${padding.base};
  `}
`

export const ProfilePicContainer = styled.div`
  position: relative;
  margin-left: 16px;
`
export const CelebrationIcon = styled.img`
  ${({theme}) => css`
    border-radius: 100px;
    position: absolute;
    width: 50%;
    height: auto;
    top: -20%;
    left: -10%;
    background-color: ${theme.colors.primary1_200};
  `}
`
